import { t } from "./kieli";

/**
 * Hitsin tunnus ruudulla: hitsinumero ensin ja korostettuna, lehti perässä toissijaisena (pääChatin toimeksianto Tonin
 * välittämänä 8.10.2026, Coworkin videokoeajo). Ennen «1/2/1» = lehti 1/2 + hitsi 1, ja koska lehden merkinnässä on itsessään
 * kauttaviiva, hitsaaja luki sen hitsiksi 2 tai alanumeroksi. Nyt «1 · lehti 1/2».
 *
 * Lehti jätetään pois kun se ei erottele mitään: tyhjä, «-» (ei lehteä) tai «1/1» (yksilehtinen linja).
 * Lehti on himmeä eikä pienempi: selite ei ole leipätekstiä pienempi (sääntö 11.9.2026), ero tehdään värillä.
 */
export function naytetaankoLehti(lehti: string | null | undefined): boolean {
  if (!lehti || lehti === "-") return false;
  const m = /^(\d+)\s*\/\s*(\d+)$/.exec(lehti.trim());
  return !(m && m[2] === "1");
}

/** Tuonnin paikanpitäjä numerokentässä (pekilo 362 riviä): tekstiä koodiarvon paikalla. Ei näytetä hitsinumerona (Toni 15.10.2026). */
export const HITSINUMERO_PAIKANPITAJA = "(suunniteltu)";
export function naytaHitsinumero(numero: string | null | undefined): string {
  const n = (numero ?? "").trim();
  return n === HITSINUMERO_PAIKANPITAJA ? "" : n;
}

export function HitsiTunnus({ numero: numeroRaaka, lehti, puuttuu }: { numero: string | null | undefined; lehti?: string | null; puuttuu?: string }) {
  const numero = naytaHitsinumero(numeroRaaka);
  return (
    <span className="hitsitunnus" data-hitsitunnus={numero ?? ""} data-lehti={lehti ?? ""}>
      {numero ? <b className="hitsitunnus__nro">{numero}</b> : <span className="dim">{puuttuu ?? "—"}</span>}
      {naytetaankoLehti(lehti) && <span className="dim hitsitunnus__lehti"> · {t("hl.lehti_pieni")} {lehti}</span>}
    </span>
  );
}
